export default "__VITE_ASSET__1269c03b__"